<div class="modal-header">
  <h2 i18n="@@card_modal.add_card">Add Card</h2>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
    <svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
      <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
    </svg>
  </button>
</div>

<!-- Modal body -->
<div class="modal-body">
  <form class="flex-container">
    <fieldset>
      <div id="credit-card-wrapper" class="textfields__wrapper">
        <fieldset class="no-label" [ngClass]="{'has-error': cardError}">
          <div id="element-container" class="h-180px"></div>
          <div class="field-error" role="alert">{{ cardError }}</div>
        </fieldset>
      </div>
    </fieldset>
    <div class="col-md-12 text-center" [hidden]="!tapUILoaded">
      <button type="button"  (click)="submit()" class="tu-btn pink" i18n="@@common.save_and_proceed">Save and Proceed</button>
    </div>
  </form><!-- end credit card information -->
</div><!-- end .modal-body -->